angular.module('iconoglobe')
.directive('divScroll',[function() {
  return {
    restrict: "AE",
    link: function(scope, element, attrs) {
      element.scroll(function(){
        var height = angular.element(".main_container").height();
        var pos = element.scrollTop();
        //     var top = cont.offset().top;
        //     var pos = height + top - 40;
        angular.element(".scrollable-area").css({
          bottom: -pos
        });
      });
    }
  };
}]);